import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { liveReportConstants } from "@data/constants/liveReportConstants"
import { liveReportService } from "@data/services/liveReportService"
import { subscriptionService } from "@data/services/subscriptionService"

// ** Helper Functions
const mergeDiagnostics = (existingDiagnostics, newDiagnostics) => {
    // Ensure existingDiagnostics is always an array
    const diagnostics = Array.isArray(existingDiagnostics)
        ? existingDiagnostics
        : existingDiagnostics
        ? [existingDiagnostics]
        : []

    const diagnosticsToMerge = Array.isArray(newDiagnostics)
        ? newDiagnostics
        : [newDiagnostics]

    let updatedDiagnostics = [...diagnostics]

    diagnosticsToMerge.forEach((newDiagnostic) => {
        const existingIndex = updatedDiagnostics.findIndex(
            (d) => d.live_report_id === newDiagnostic.live_report_id
        )

        if (existingIndex === -1) {
            // Add new diagnostic if it doesn't exist
            updatedDiagnostics.push(newDiagnostic)
        } else {
            // Update existing diagnostic
            updatedDiagnostics[existingIndex] = {
                ...updatedDiagnostics[existingIndex],
                ...newDiagnostic,
            }
        }
    })

    return updatedDiagnostics
}

// ** Initial State
const initialState = {
    liveReports: [],
    diagnostics: [],
}

export function liveReports(state = initialState, action) {
    switch (action.type) {
        case liveReportService.getStudentLiveReports.name +
            apiConstants._SUCCESS: {
            let liveReports = []
            if (action.data?.meta?.current_page === 1) {
                liveReports = action.data?.live_reports
            } else {
                liveReports = state.liveReports?.concat(
                    action.data?.live_reports
                )
            }
            return {
                ...state,
                liveReports: liveReports,
            }
        }

        case liveReportService.setStudentDiagnostic.name +
            apiConstants._SUCCESS:
        case liveReportConstants.SAVE_DIAGNOSTIC:
            return {
                ...state,
                diagnostics: mergeDiagnostics(state.diagnostics, action.data),
            }

        case liveReportService.getStudentLiveReportsWithDiagnostic.name +
            apiConstants._SUCCESS: {
            const studentDiagnostics = action.data?.map(
                (liveReport) => liveReport?.student_diagnostic
            )

            return {
                ...state,
                diagnostics: mergeDiagnostics(
                    state.diagnostics,
                    studentDiagnostics
                ),
            }
        }

        case liveReportConstants.DELETE_DIAGNOSTIC:
            return {
                ...state,
                diagnostics: (state.diagnostics || []).filter(
                    (d) => d.live_report_id !== action.liveReportId
                ),
            }

        case liveReportConstants.CLEAR_DIAGNOSTICS:
            return {
                ...state,
                diagnostics: [],
            }

        case subscriptionService.getLastReport.name + apiConstants._SUCCESS: {
            // Add the last report to the beginning of the liveReports array
            const newReport = action.data?.last_report
            const reportType = action.data?.report_type

            if (!newReport) {
                return {
                    ...state,
                    liveReports: [],
                }
            }

            return {
                ...state,
                liveReports: [{ ...newReport, report_type: reportType }],
            }
        }

        case authConstants.SWITCH_ACCOUNT:
            // Reset to initial state when switching accounts (e.g., parent switching between children)
            return initialState

        default:
            return state
    }
}

export default liveReports
